import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
import JsonCSV from 'vue-json-csv';
let BaseCsvExporter = class BaseCsvExporter extends Vue {
    constructor() {
        super(...arguments);
        this.loading = false;
    }
    exportFinished(val) {
        this.$emit('exportFinished', val);
    }
};
__decorate([
    Prop({ type: Array, required: false })
], BaseCsvExporter.prototype, "csvData", void 0);
__decorate([
    Prop({ type: Object, required: false })
], BaseCsvExporter.prototype, "csvLabels", void 0);
__decorate([
    Prop({ type: Array, required: false })
], BaseCsvExporter.prototype, "csvFields", void 0);
__decorate([
    Prop({ type: String, required: false })
], BaseCsvExporter.prototype, "csvName", void 0);
BaseCsvExporter = __decorate([
    Component({
        components: {
            JsonCSV,
        },
    })
], BaseCsvExporter);
export default BaseCsvExporter;
